import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GtagModule } from 'angular-gtag';
import { Title } from '@angular/platform-browser';
import { from } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { Translations } from './localization/translations.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
} from '@angular/material';

import { AppComponent } from './app.component';
import { DirectivesModule } from './directives/directives.module'; // ajuste o caminho
import { NgSelectModule } from '@ng-select/ng-select';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FixedpluginModule } from './shared/fixedplugin/fixedplugin.module';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../app/auth/auth.interceptor';
import { AppRoutes } from './app.routing';
import { RedirectGuard } from 'src/assets/helpers/redirect-guard';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { SharedModule } from './shared.module';
import { FileUploadModalComponent } from './files/file-upload-modal/file-upload-modal.component';
import { FolderCreationModalComponent } from './files/folder-creation-modal/folder-creation-modal.component';
import { MatFileUploadModule } from 'angular-material-fileupload'
import { FolderNamePipe } from './files/folder-name.pipe';
import { MenuCreationFormComponent } from './roles/pages/menu-creation-form/menu-creation-form.component';
import { PbiModule } from './pbi/pbi.module';
import { SampleModule } from './pbi/sample/sample.module';
import { RecordCreationModalComponent } from './roles/components/record-creation-modal/record-creation-modal.component';

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string) {
    return from(import(`../assets/i18n/${lang}.ts`)).pipe(pluck('default'));
  }
}

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
  ]
})
export class MaterialModule {}

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: WebpackTranslateLoader,
      },
      defaultLanguage: 'en',
    }),
    GtagModule.forRoot({ trackingId: 'G-SDJ39CX00D', trackPageviews: false }),
    HttpModule,
    HttpClientModule,
    MaterialModule,
    SidebarModule,
    NgSelectModule,
    NavbarModule,
    FooterModule,
    FixedpluginModule,
    MatFileUploadModule,
    PbiModule,
    SampleModule,
    ReactiveFormsModule
  ],
  declarations: [AppComponent, AdminLayoutComponent, AuthLayoutComponent, FileUploadModalComponent, FolderCreationModalComponent, MenuCreationFormComponent, FolderNamePipe, RecordCreationModalComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    Title,
    RedirectGuard,
    Translations,
  ],
  bootstrap: [AppComponent],
  entryComponents: [FileUploadModalComponent, FolderCreationModalComponent, MenuCreationFormComponent, RecordCreationModalComponent]
})
export class AppModule {}
